import styled from 'styled-components';

import variables from '../../../styles/variables';
import Link from '../../UI/Link/Link';
import { KioskProps } from '../../../types';

export const Card = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  max-width: 100%;
  width: 100%;
  height: 100%;
  position: relative;
  margin: 0 auto;
  padding: 20px 20px 67px;
  border-radius: 15px;
  background-color: #fff;
  text-decoration: none;
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 8px 0px;
  transition: all 0.5s !important;
  width: 282px !important;

  @media screen and (max-width: 1280px) {
    width: 100% !important;
  }

  @media screen and (max-width: 767px) {
    padding: 20px;
    justify-content: center;
  }

  // Grid fix for Safari
  @media not all and (min-resolution: 0.001dpcm) {
    @supports (-webkit-appearance: none) and (display: flow-root) {
      height: auto;
    }
  }

  &:hover,
  &:focus {
    z-index: 2;
    box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.15) !important;
  }

  &.product-carousel {
    align-self: stretch;
    height: auto;

    img {
      width: auto;
      max-width: 100%;
      height: 200px;
      margin: 0 auto;
      object-fit: contain;
    }

    .gatsby-image-wrapper {
      margin: 0 auto;
    }
  }

  img {
    width: auto;
    max-width: 100%;
    height: 200px;
    margin: 0 auto;
    object-fit: cover;
  }

  .gatsby-image-wrapper {
    margin: 0 auto;
  }
`;

export const Manufacturer = styled.div`
  width: 100%;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  line-height: 20.11px;
  text-align: left;
  margin-bottom: 0;
`;

export const Product = styled.div`
  width: 100%;
  font-size: 14px;
  line-height: 18.2px;
  letter-spacing: -0.06px;
  text-align: left;
  font-weight: normal;
  height: 38px;

  // Add ellipsis at end of second line
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; 
  -webkit-box-orient: vertical;

  p {
    margin-bottom: 0;
  }
`;

export const ColourWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  max-width: 100%;
  width: 100%;
  position: relative;
`;

export const Colour = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 8px;
  margin-right: 0.5rem;
  cursor: pointer;
  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.2);

  &.default {
    background: linear-gradient(
      -45deg,
      #333,
      #333 50%,
      #333 49%,
      white 51%,
      white 51%
    );
    border-radius: 50%;
    box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.2);
  }

  &.extra {
    background: none;
    color: #9b9b9b;
    box-shadow: none;
    margin-top: -0.1rem;
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;

  &.view-desktop {
    display: flex;

    @media (max-width: 640px) {
      display: none;
    }

    &.compatible {
      display: none;

      @media (max-width: 640px) {
        display: none;
      }
    }
  }

  &.view-mobile {
    display: none;

    @media (max-width: 640px) {
      display: flex;
    }

    &.compatible {
      display: flex;

      @media (max-width: 640px) {
        display: flex;
      }
    }
  }

  img {
    object-fit: contain;
  }
`;

export const CardFooter = styled.div`
  width: calc(100% - 40px);
  position: absolute;
  bottom: 20px;
  @media screen and (max-width: 767px) {
    position: relative;
    bottom: 0;
  }
`;

export const From = styled.div`
  display: block;
  position: relative;
  text-align: left;
  top: 4px;
  padding-right: 2px;
  font-size: 14px;
  font-weight: normal;

  @media only screen and (max-width: 768px) {
    font-size: 12px;
  }

  &:lang(fr) {
    font-size: 10px;

    @media only screen and (max-width: 768px) {
      font-size: 10px;
    }
  }
`;

export const PerMonth = styled.div`
  display: block;
  position: relative;
  text-align: left;
  padding-right: 2px;
  font-size: 14px;
  font-weight: normal;

  @media only screen and (max-width: 768px) {
    font-size: 12px;
  }

  &:lang(fr) {
    font-size: 10px;

    @media only screen and (max-width: 768px) {
      font-size: 10px;
    }
  }
`;

export const ValueWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;

  @media screen and (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
`;

export const Dollar = styled.div`
  display: flex;
  width: 100%;
  font-size: 26px;
  line-height: 29.04px;
  letter-spacing: -0.68px;
  font-weight: 600;

  @media screen and (max-width: 640px) {
    font-size: 22px;
  }

  @media screen and (max-width: 480px) {
    font-size: 20px;
  }
`;

export const Points = styled.div<KioskProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  color: ${variables.colorRed};
  width: 100%;

  @media screen and (max-width: 480px) {
    align-items: flex-start;
    justify-content: flex-start;
    margin-top: 7px;
  }

  span {
    width: 100%;
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    font-weight: 600;

    &.text {
      font-size: ${({ isKiosk }) => isKiosk ? variables.defaultMinFontSizeKiosk : 8}px;
      text-align: left;
      font-weight: normal;
    }

    .pts {
      img {
        margin-left: 0.25rem;
        width: 15.36px;
        height: 10.99px;
        margin-top: 4px;
        margin: 0;

        &:lang(fr) {
          width: 16.36px;
        }
      }
    }
  }
`;
